export const LinkWithUrl = (props: any) => {
  return (
    <a href={props.url} target="_blank" rel="noopener noreferrer" style={props.style}>
      {props.children}
    </a>
  )
}
